import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { v2ErrorMessage } from '../../../shared/utils/v2-api-response.util';
import { Efectivo } from '../../../../models/finanzas/efectivo/efectivo.model';

export interface CashListFilter {
  page: number;
  pageSize: number;
  search?: string;
  sortField?: string;
  sortDirection?: string;
}

export interface CashListSummary {
  count: number;
  totalBalance: number;
  totalCashFund: number;
}

export interface CashListResult {
  items: Efectivo[];
  total: number;
  summary: CashListSummary;
}

export const EMPTY_CASH_SUMMARY: CashListSummary = {
  count: 0,
  totalBalance: 0,
  totalCashFund: 0,
};

@Injectable({ providedIn: 'root' })
export class CashReadService {
  private readonly baseUrl = `${environment.apiUrl}/api/v2/cashs`;

  constructor(private http: HttpClient) { }

  list(filter: CashListFilter): Promise<CashListResult> {
    const fallback = 'No se pudo cargar la lista de cajas';
    return firstValueFrom(this.http.post<any>(`${this.baseUrl}/list`, filter))
      .catch(error => {
        throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, fallback) } };
      })
      .then(response => {
        if (!response || response.isSuccess === false) {
          throw { error: { message: v2ErrorMessage(response, fallback) } };
        }
        return {
          items: Array.isArray(response.values) ? response.values : [],
          total: Number(response.total) || 0,
          summary: response.summary || { ...EMPTY_CASH_SUMMARY },
        };
      });
  }
}
